/**
 * American Original Repellents — landing + embedded store interactivity.
 *
 * This file is loaded as a real theme asset (via <script src="..." defer>)
 * rather than an inline <script> block. Some themes/CSP configurations block
 * inline scripts and/or inline event-handler attributes silently — moving
 * this to a proper asset file sidesteps that entire category of problem,
 * since external scripts served from Shopify's own CDN are governed by a
 * different, more permissive part of most CSP configurations.
 *
 * All per-instance dynamic data (block-driven sizes, FAQs, image URLs, the
 * section's unique id) is read from a hidden data element's attributes
 * rather than being templated directly into JS, since this file itself is
 * static and cannot contain Liquid.
 */
(function () {
  'use strict';

  function decodeJSON(base64) {
    if (!base64) return [];
    try {
      // atob() alone treats the decoded data as Latin-1, which corrupts any
      // multi-byte UTF-8 characters (×, em-dashes, curly quotes, etc). Decode
      // the raw bytes properly as UTF-8 before parsing.
      var binary = atob(base64);
      var bytes = new Uint8Array(binary.length);
      for (var i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      var text = new TextDecoder('utf-8').decode(bytes);
      return JSON.parse(text);
    } catch (e) {
      return [];
    }
  }

  function initInstance(dataEl) {
    var sid = dataEl.getAttribute('data-section-id');
    if (!sid) return;

    var SIZES = decodeJSON(dataEl.getAttribute('data-sizes'));
    var FAQS = decodeJSON(dataEl.getAttribute('data-faqs'));
    var BOTTLE_IMG = dataEl.getAttribute('data-bottle-img') || '';

    var landingRoot = document.getElementById('ao-view-landing-' + sid);
    var storeRoot = document.getElementById('ao-view-store-' + sid);

    function el(id) { return document.getElementById(id + '-' + sid); }

    // ---------- landing <-> store view switching ----------
    function showStore() {
      if (landingRoot) landingRoot.style.display = 'none';
      if (storeRoot) storeRoot.style.display = 'block';
      window.scrollTo(0, 0);
    }
    function showLanding() {
      if (storeRoot) storeRoot.style.display = 'none';
      if (landingRoot) landingRoot.style.display = 'block';
      window.scrollTo(0, 0);
    }

    // ---------- reveal-on-scroll (safe by default; only animates if this runs) ----------
    if (landingRoot && typeof IntersectionObserver !== 'undefined') {
      var revealEls = landingRoot.querySelectorAll('.ao-reveal');
      if (revealEls.length) {
        landingRoot.classList.add('ao-js-ready');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('ao-in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        revealEls.forEach(function (elm) { io.observe(elm); });
        setTimeout(function () {
          revealEls.forEach(function (elm) { elm.classList.add('ao-in'); });
        }, 2500);
      }
    }

    // ---------- store: sizes / cart / checkout / faq ----------
    var defaultSize = SIZES.filter(function (s) { return /(^|[^0-9])8\s*oz/i.test(s.label || ''); })[0] || SIZES[0]; var selectedSize = defaultSize ? defaultSize.id : null;
    var qty = 1;
    var cart = [];

    function renderOptions() {
      var sizeWrap = el('storeSizeOptions');
      if (!sizeWrap) return;
      sizeWrap.innerHTML = SIZES.map(function (s) {
        return '<button class="aos-opt-btn ' + (s.id === selectedSize ? 'aos-active' : '') +
          '" data-ao-action="select-size" data-ao-size-id="' + s.id + '">' +
          s.label + '<small>$' + s.price.toFixed(2) + '</small></button>';
      }).join('');

      var currentSize = SIZES.filter(function (s) { return s.id === selectedSize; })[0];
      var photoWrap = document.getElementById('storeShopPhotoImg-' + sid);
      if (currentSize && photoWrap && currentSize.img) {
        photoWrap.innerHTML = '<img src="' + currentSize.img + '" alt="">';
      }

      updatePriceDisplay();
    }
    function selectSize(id) { selectedSize = id; renderOptions(); }

    function currentUnitPrice() {
      var s = SIZES.filter(function (s) { return s.id === selectedSize; })[0];
      return s ? s.price : 0;
    }
    function updatePriceDisplay() {
      var d = el('storePriceDisplay');
      if (d) d.textContent = '$' + currentUnitPrice().toFixed(2);
    }
    function changeQty(delta) {
      qty = Math.max(1, qty + delta);
      var q = el('storeQtyVal');
      if (q) q.textContent = qty;
    }

    function addToCart() {
      var sizeObj = SIZES.filter(function (s) { return s.id === selectedSize; })[0];
      if (!sizeObj) return;
      var key = selectedSize;
      var existing = cart.filter(function (i) { return i.key === key; })[0];
      if (existing) { existing.qty += qty; }
      else { cart.push({ key: key, size: sizeObj.label, price: currentUnitPrice(), qty: qty }); }
      renderCart();
      showToast('Added ' + qty + ' \u00d7 ' + sizeObj.label + ' to cart');
      qty = 1;
      var q = el('storeQtyVal');
      if (q) q.textContent = 1;
      openCart();
    }

    function renderCart() {
      var itemsWrap = el('storeCartItems');
      var foot = el('storeCartFoot');
      var countEl = el('storeCartCount');
      var totalQty = cart.reduce(function (a, i) { return a + i.qty; }, 0);
      if (countEl) countEl.textContent = totalQty;

      if (!itemsWrap) return;
      if (cart.length === 0) {
        itemsWrap.innerHTML = '<div class="aos-cart-empty">Your cart is empty.<br>Head back to the shop to gear up.</div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = 'block';
      itemsWrap.innerHTML = cart.map(function (item, idx) {
        return '<div class="aos-cart-item">' +
          '<img src="' + BOTTLE_IMG + '" alt="Trailhead bottle">' +
          '<div class="aos-cart-item-info"><h4>Trailhead Bug Spray</h4>' +
          '<div class="aos-meta">' + item.size + '</div>' +
          '<div class="aos-cart-item-row"><div class="aos-cart-item-qty">' +
          '<button data-ao-action="update-cart-qty" data-ao-idx="' + idx + '" data-ao-delta="-1">\u2212</button>' +
          '<span>' + item.qty + '</span>' +
          '<button data-ao-action="update-cart-qty" data-ao-idx="' + idx + '" data-ao-delta="1">+</button></div>' +
          '<div class="aos-cart-item-price">$' + (item.price * item.qty).toFixed(2) + '</div></div>' +
          '<button class="aos-remove-link" data-ao-action="remove-cart-item" data-ao-idx="' + idx + '">Remove</button>' +
          '</div></div>';
      }).join('');

      var subtotal = cart.reduce(function (a, i) { return a + i.price * i.qty; }, 0);
      var st = el('storeCartSubtotal');
      if (st) st.textContent = '$' + subtotal.toFixed(2);
    }
    function updateCartQty(idx, delta) {
      cart[idx].qty += delta;
      if (cart[idx].qty <= 0) cart.splice(idx, 1);
      renderCart();
    }
    function removeCartItem(idx) { cart.splice(idx, 1); renderCart(); }

    function openCart() {
      var d = el('storeCartDrawer'), o = el('storeOverlay');
      if (d) d.classList.add('aos-show');
      if (o) o.classList.add('aos-show');
    }
    function closeCart() {
      var d = el('storeCartDrawer'), o = el('storeOverlay');
      if (d) d.classList.remove('aos-show');
      if (o) o.classList.remove('aos-show');
    }
    function scrollToShop() {
      var s = document.getElementById('store-shop-' + sid);
      if (s) s.scrollIntoView({ behavior: 'smooth' });
    }

    function showToast(msg) {
      var t = el('storeToast');
      if (!t) return;
      t.textContent = msg;
      t.classList.add('aos-show');
      clearTimeout(t._aoTimer);
      t._aoTimer = setTimeout(function () { t.classList.remove('aos-show'); }, 2600);
    }

    function openCheckout() {
      if (cart.length === 0) return;
      var fv = el('storeCheckoutFormView'), cv = el('storeCheckoutConfirmView');
      if (fv) fv.style.display = 'block';
      if (cv) cv.style.display = 'none';
      var subtotal = cart.reduce(function (a, i) { return a + i.price * i.qty; }, 0);
      var shipping = subtotal > 30 ? 0 : 5.99;
      var tax = subtotal * 0.07;
      var orderTotal = subtotal + shipping + tax;
      var os = el('storeOrderSummary');
      if (os) {
        os.innerHTML =
          '<div class="aos-row"><span>Subtotal</span><span>$' + subtotal.toFixed(2) + '</span></div>' +
          '<div class="aos-row"><span>Shipping</span><span>' + (shipping === 0 ? 'Free' : '$' + shipping.toFixed(2)) + '</span></div>' +
          '<div class="aos-row"><span>Estimated tax</span><span>$' + tax.toFixed(2) + '</span></div>' +
          '<div class="aos-row aos-total"><span>Total</span><span>$' + orderTotal.toFixed(2) + '</span></div>';
      }
      var co = el('storeCheckoutOverlay');
      if (co) co.classList.add('aos-show');
      closeCart();
    }
    function closeCheckout() {
      var co = el('storeCheckoutOverlay');
      if (co) co.classList.remove('aos-show');
    }

    function placeOrder(e) {
      e.preventDefault();
      var orderNum = 'TH-' + Math.floor(10000 + Math.random() * 89999);
      var fv = el('storeCheckoutFormView');
      if (fv) fv.style.display = 'none';
      var confirmView = el('storeCheckoutConfirmView');
      if (confirmView) {
        confirmView.style.display = 'block';
        confirmView.innerHTML =
          '<div class="aos-confirm-view">' +
          '<svg class="aos-confirm-icon" viewBox="0 0 24 24" fill="none" stroke="#37432E" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-6"/></svg>' +
          '<h2>Order Placed!</h2>' +
          '<p style="color:var(--ink-soft); font-size:14.5px;">Thanks for gearing up with Trailhead. A confirmation would normally be sent to your email.</p>' +
          '<div class="aos-confirm-order-num">Order #' + orderNum + '</div>' +
          '<p class="aos-demo-note">Demo only \u2014 connect a real payment processor and order system to go live.</p>' +
          '<button class="aos-btn-outline" style="margin-top:10px;" data-ao-action="finish-order">Continue Shopping</button>' +
          '</div>';
      }
      cart = [];
      renderCart();
      return false;
    }
    function finishOrder() {
      closeCheckout();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function joinNewsletter(e) {
      e.preventDefault();
      showToast("You're on the trail log! Check your inbox to confirm.");
      e.target.reset();
      return false;
    }

    function renderFaq() {
      var list = el('storeFaqList');
      if (!list) return;
      list.innerHTML = FAQS.map(function (f, idx) {
        return '<div class="aos-faq-item" id="storeFaq-' + idx + '-' + sid + '">' +
          '<div class="aos-faq-q" data-ao-action="toggle-faq" data-ao-idx="' + idx + '"><span>' + f.q + '</span><span class="aos-plus">+</span></div>' +
          '<div class="aos-faq-a">' + f.a + '</div></div>';
      }).join('');
    }
    function toggleFaq(idx) {
      var item = document.getElementById('storeFaq-' + idx + '-' + sid);
      if (item) item.classList.toggle('aos-open');
    }

    // ---------- event delegation (click + submit) for this instance ----------
    if (storeRoot) {
      storeRoot.addEventListener('click', function (e) {
        var target = e.target.closest('[data-ao-action]');
        if (!target || !storeRoot.contains(target)) return;
        var action = target.getAttribute('data-ao-action');
        var idx = target.getAttribute('data-ao-idx');
        var delta = target.getAttribute('data-ao-delta');
        switch (action) {
          case 'open-cart': openCart(); break;
          case 'close-cart': closeCart(); break;
          case 'scroll-to-shop': scrollToShop(); break;
          case 'change-qty': changeQty(parseInt(delta, 10)); break;
          case 'add-to-cart': addToCart(); break;
          case 'open-checkout': openCheckout(); break;
          case 'close-checkout': closeCheckout(); break;
          case 'select-size': selectSize(target.getAttribute('data-ao-size-id')); break;
          case 'update-cart-qty': updateCartQty(parseInt(idx, 10), parseInt(delta, 10)); break;
          case 'remove-cart-item': removeCartItem(parseInt(idx, 10)); break;
          case 'finish-order': finishOrder(); break;
          case 'toggle-faq': toggleFaq(parseInt(idx, 10)); break;
        }
      });
      storeRoot.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-ao-form]');
        if (!form || !storeRoot.contains(form)) return;
        var kind = form.getAttribute('data-ao-form');
        if (kind === 'newsletter') { joinNewsletter(e); }
        else if (kind === 'place-order') { placeOrder(e); }
      });
    }

    // show-store / show-landing clicks can originate in either view
    document.addEventListener('click', function (e) {
      var target = e.target.closest('[data-ao-action="show-store"], [data-ao-action="show-landing"]');
      if (!target) return;
      if (!landingRoot || !storeRoot) return;
      if (!landingRoot.contains(target) && !storeRoot.contains(target)) return;
      e.preventDefault();
      if (target.getAttribute('data-ao-action') === 'show-store') { showStore(); }
      else { showLanding(); }
    });

    renderOptions();
    renderCart();
    renderFaq();
  }

  function init() {
    var dataEls = document.querySelectorAll('[data-ao-instance]');
    dataEls.forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Mobile browsers (especially iOS Safari) often restore a page from the
  // back-forward cache instead of doing a fresh load when you navigate back
  // or resume a suspended tab. That restores the *previous* JS-mutated DOM
  // state, including whichever view (landing/store) was showing when you
  // left — which can make the page appear to "start" on the store view even
  // though a true fresh load always starts on the landing view. Force every
  // instance back to its landing view whenever a bfcache restore happens.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-ao-instance]').forEach(function (dataEl) {
      var sid = dataEl.getAttribute('data-section-id');
      if (!sid) return;
      var landingRoot = document.getElementById('ao-view-landing-' + sid);
      var storeRoot = document.getElementById('ao-view-store-' + sid);
      if (landingRoot) landingRoot.style.display = 'block';
      if (storeRoot) storeRoot.style.display = 'none';
    });
  });
})();
